import { DateTime } from "luxon";

import type { TGetBroadcastStatusResponse } from "@api/broadcast";

export const timeTestDiff = (timestamp: number, broadcastData: TGetBroadcastStatusResponse) => {
	const nowFromBSS = broadcastData.broadcastDurationSec + broadcastData.startedAt;
	const nowMomentBC = DateTime.fromSeconds(nowFromBSS);
	const clientMoment = DateTime.fromSeconds(timestamp);
	const diff = nowMomentBC.diff(clientMoment, ["hours", "minutes", "seconds"]);
	return diff;
};
